let timelineElements = [
    {
        id: 1,
        location: "UTD Human-Centered eXtended Reality (HeXD) Lab",
        position: "Undergraduate Researcher",
        description: " ",
        date: "Feb 2024 - Present",
    },
    {
        id: 2,
        location: "Pearson - Durham, NC",
        position: "Software Engineering Intern",
        description: " ",
        date: "Jun 2025 - Aug 2025",
    },
    {
        id: 3,
        location: "University of Texas at Dallas",
        position: "Bachelor of Science in Computer Science",
        description: " Organizations: HackUTD, Association for Computing Machinery, Women Mentoring Women in Engineering",
        date: "Aug 2023 - May 2026",
    },
];

export default timelineElements;